import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ErrorPage from "../../components/shared/errorPage/ErrorPage";
import { LOCALSESSIONDATAKEYS, SUBSCRIPTIONKIND } from "../../constants/AppConstants";
import Loader from "../../components/shared/loader/Loader";
import { setLocalSessionData } from "../../utils/Authentication/handleUserSession";

import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { nativeAppRoutePaths, routePath } from "../../constants/Routes";
import { 
  getSignupTypeBy_SubscriptionKind, 
  isDesktopOrBmcClient,
  validatesHwIncBySubscriptionKind
} from "../../constants/AppMethod";

const CustomerRedirection = (props) => {
  const { t } = useTranslation(["translation"]);
  const { RouterLinkStateProp, upgradeTo_EcoProProcess }  = props;
  const UserAccount = useSelector((state) => state.UserAccount);
  const IsUpgradeToEcoPro = upgradeTo_EcoProProcess;
  const isNativeApp = isDesktopOrBmcClient();
  const subscriptionkind = UserAccount.userAccount.subscriptionKind;
  const isHwInc = validatesHwIncBySubscriptionKind(subscriptionkind);

  const setSignupType = () => {
    const signUpType = getSignupTypeBy_SubscriptionKind(subscriptionkind);
    setLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE, signUpType);
  }

  useEffect(() => {
    if((subscriptionkind === SUBSCRIPTIONKIND.WEB
      || isHwInc)
      && (!IsUpgradeToEcoPro)
    ){
        setSignupType();
    }
     // eslint-disable-next-line
  }, []);
 
  if(!UserAccount.userAccount.businessPartnerId && !IsUpgradeToEcoPro){
    return <ErrorPage errorInfo={t('ERROR_CONTENT.CANT_CREATE_SUBSCRIPTION')}></ErrorPage>
  }
  /**
   * Handles flow when triggered from native apps [IPS, EasySetup, mobileconnect].
   * If subscription type is 'HardwareInclusive', initiates the 'HardwareInclusive' registration process.
   */
  if(isNativeApp && isHwInc){
    return <Redirect to = {{
      pathname: nativeAppRoutePaths.HWINC.REGISTER_SERVICE, 
      subscriptionKind: subscriptionkind
    }}></Redirect>
  }
  
  if(UserAccount.userAccount.businessPartnerId) {
    return <Redirect to= {{pathname: routePath.PROCESS_DEVICE, 
                          state: {
                            RouterLinkStateProp: RouterLinkStateProp,
                            source: UserAccount.userAccount.enrollmentService,
                            IsUpgradeToEcoPro:  IsUpgradeToEcoPro,
                            subscriptionKind: subscriptionkind
                          }
                        }}
            />
  }

  return <Loader></Loader>
};

export default CustomerRedirection;
